export default __webpack_public_path__ + "images/1e6c9c15480d7eb67c689e64ba5f8f4d-tank2.png";